import { TemplateRef } from '@angular/core';
import { CementoCotizacionVm } from '../../../stores/cotizaciones-cemento.store';
import {
  AdminServerTableCellContext,
  AdminServerTableColumn,
} from '../../../shared/table/models/admin-server-table.model';

interface CotizacionesColumnsTemplates {
  priceCellTemplate: TemplateRef<
    AdminServerTableCellContext<CementoCotizacionVm>
  >;
  actionsCellTemplate: TemplateRef<
    AdminServerTableCellContext<CementoCotizacionVm>
  >;
}

export function buildCotizacionesCementoColumns(
  templates: CotizacionesColumnsTemplates,
): AdminServerTableColumn<CementoCotizacionVm>[] {
  return [
    {
      id: 'created_at',
      header: 'Solicitado',
      sortable: true,
      sortKey: 'created_at',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.created_at_formatted,
    },
    {
      id: 'order_buy',
      header: 'Código',
      sortable: true,
      sortKey: 'order_buy',
      cellClass: 'admin-col-nowrap fw-bold',
      value: (row) => row.order_buy,
    },
    {
      id: 'name',
      header: 'Cliente',
      sortable: true,
      sortKey: 'name',
      headerClass: 'admin-col-truncate-client',
      cellClass: 'admin-col-truncate-client',
      value: (row) => row.name,
      title: (row) => row.name,
    },
    {
      id: 'product_name',
      header: 'Producto',
      sortable: true,
      sortKey: 'product',
      headerClass: 'admin-col-truncate-lg',
      cellClass: 'admin-col-truncate-lg',
      value: (row) => row.product_name,
      title: (row) => row.product_name,
    },
    {
      id: 'incoterm_display',
      header: 'Tipo de entrega',
      sortable: true,
      sortKey: 'incoterm',
      headerClass: 'admin-col-truncate-md',
      cellClass: 'admin-col-truncate-md',
      value: (row) => row.incoterm_display,
      title: (row) => row.incoterm_display,
    },
    {
      id: 'request_amount',
      header: 'Cant. (Pallets)',
      sortable: true,
      sortKey: 'request_amount',
      headerClass: 'admin-col-width-sm',
      cellClass: 'admin-col-num admin-col-width-sm',
      value: (row) => row.request_amount,
    },
    {
      id: 'total_price',
      header: 'Total',
      sortable: true,
      sortKey: 'total_price',
      cellClass: 'admin-col-num admin-col-nowrap',
      cellTemplate: templates.priceCellTemplate,
    },
    {
      id: 'state_display',
      header: 'Estado',
      sortable: true,
      sortKey: 'state',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.state_display,
    },
    {
      id: 'schedule_date',
      header: 'Entrega',
      sortable: true,
      sortKey: 'schedule_date',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.schedule_date_formatted,
    },
    {
      id: 'expires_at',
      header: 'Vence',
      sortable: true,
      sortKey: 'expires_at',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.expires_at_formatted,
    },
    {
      id: 'acciones',
      header: 'Acciones',
      sortable: false,
      headerClass: 'admin-col-actions',
      cellClass: 'admin-col-actions',
      cellTemplate: templates.actionsCellTemplate,
      title: () => '',
    },
  ];
}
